import { CloudUpload, Upload } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import { useDropzone } from "react-dropzone";

interface FileDropzoneProps {
  onDrop: (acceptedFiles: File[]) => void;
}

const FileDropzone: React.FC<FileDropzoneProps> = ({ onDrop }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".gif"],
    },
    multiple: true,
  });

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Upload Photos
      </Typography>

      <Box
        {...getRootProps()}
        sx={{
          border: "2px dashed",
          borderColor: isDragActive ? "primary.main" : "grey.300",
          borderRadius: 3,
          p: 6,
          textAlign: "center",
          cursor: "pointer",
          backgroundColor: isDragActive ? "action.hover" : "background.paper",
          transition: "all 0.3s ease",
          "&:hover": {
            borderColor: "primary.main",
            backgroundColor: "action.hover",
            transform: "scale(1.02)",
          },
        }}
      >
        <input {...getInputProps()} />

        {/* Upload Icon */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #892c8b 0%, #a855a7 100%)",
            borderRadius: "50%",
            width: 80,
            height: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 3,
            boxShadow: "0 8px 25px rgba(137, 44, 139, 0.3)",
          }}
        >
          <CloudUpload sx={{ fontSize: 40, color: "white" }} />
        </Box>

        {/* Main Text */}
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
          {isDragActive
            ? "Drop photos here"
            : "Drag & drop multiple photos here"}
        </Typography>

        {/* Secondary Text */}
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 2 }}
        >
          or click to select files
        </Typography>

        {/* File Support Chip */}
        <Chip
          icon={<Upload />}
          label="Supports multiple files"
          color="primary"
          variant="outlined"
          sx={{ borderRadius: 2 }}
        />
      </Box>
    </Box>
  );
};

export default FileDropzone;